import * as React from 'react';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Box, Button } from '@mui/material';
import c from '../images/coldplay.jpg'; 
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

export default function ColdplayTour() {
  return (
    <Box sx={{ 
      minHeight: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      backgroundColor: '#121212', // Dark background color
      color: '#fff', // Default text color to white
    }}>
      <Box>
        <Card
          sx={{
            position: 'relative',
            borderRadius: '6px',
            overflow: 'hidden',
            height: '35vh',
            width: '100%',
            marginTop: 0,
            padding: 0,
            margin: 0,
          }}
        >
          <CardMedia
            component="img"
            height="100%"
            image={c}
            alt="Coldplay"
            sx={{
              position: 'relative',
              width: '100%',
              height: '100%',
              objectPosition: 'center top',
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              height: '100%',
              background:
                'linear-gradient(to top, rgba(0,0,0,0.6), rgba(0,0,0,0) 35%),' +
                'linear-gradient(to top, rgba(0,0,0,0.75), rgba(0,0,0,0) 40%)' +
                'rgba(0, 0, 0, 0.2)',
            }}
          />
          <Typography
            variant="h5"
            component="div"
            sx={{
              position: 'absolute',
              bottom: 12,
              left: 18,
              fontSize: 34,
              fontWeight: 'bold',
            }}
          >
            Coldplay
          </Typography>
        </Card>

        {/* Date and Location Section */}
        <Box sx={{ display: 'flex', alignItems: 'center', paddingLeft: '16px', paddingTop: '8px', margin: 0 }}>
          <CalendarTodayIcon /> 
          <Typography variant="body1" sx={{ marginLeft: '4px' }}>
            November 2024
          </Typography>
        </Box>

        {/* About Section */}
        <Box sx={{ padding: '16px', marginTop: '30px' }}>
          <Typography 
            variant="h6" 
            sx={{ 
              marginBottom: '8px', 
              fontWeight: 'bold', 
              fontSize: '20px', 
              color: '#f2994a' 
            }}>
            About
          </Typography>
          <Typography variant="body2">
            Coldplay has extended their Music Of The Spheres World Tour with performances in Australia during November 2024. 
            The band will play multiple shows at Sydney's Accor Stadium and Melbourne's Cricket Ground.
          </Typography>
        </Box>

        {/* Setlist Section */}
        <Box sx={{ padding: '16px', marginTop: '20px' }}>
          <Typography 
              variant='h6' 
              sx={{
                  marginBottom: '8px', 
                  fontWeight: 'bold', 
                  fontSize: '20px', 
                  color: '#f2994a' 
              }}>
              Setlist (Highlights)
          </Typography>
          <Box component="ul" sx={{ margin: 0, paddingLeft: '20px', listStyleType: 'disc', color: '#fff' }}>
            <Typography component="li" variant="body2">
              Higher Power
            </Typography>
            <Typography component="li" variant="body2">
              Adventure of a Lifetime
            </Typography>
            <Typography component="li" variant="body2">
              Paradise
            </Typography>
            <Typography component="li" variant="body2">
              The Scientist
            </Typography>
            <Typography component="li" variant="body2">
              Viva la Vida
            </Typography>
          </Box>
        </Box>

        {/* Tickets Section */}
        <Box sx={{ padding: '16px', marginTop: '20px' }}>
          <Typography 
            variant="h6" 
            sx={{ 
              marginBottom: '8px', 
              fontWeight: 'bold', 
              fontSize: '20px', 
              color: '#f2994a' 
            }}>
            Tickets
          </Typography>
          <Box sx={{ display: 'flex', gap: '8px' }}>
            <Button 
              variant="contained" 
              sx={{ backgroundColor: '#f2994a', color: '#121212', fontWeight: 'bold' }}
              href="https://www.ticketmaster.com.au/coldplay-tickets/artist/806431" // Replace with your link
              target="_blank" 
              rel="noopener noreferrer" 
            >
              Sydney
            </Button>
            <Button 
              variant="contained" 
              sx={{ backgroundColor: '#f2994a', color: '#121212', fontWeight: 'bold' }}
              href="https://www.ticketmaster.com.au/coldplay-tickets/artist/806431" // Replace with your link
              target="_blank" 
              rel="noopener noreferrer" 
            >
              Melbourne
            </Button>
          </Box>
        </Box>
      </Box>

      {/* Footer Section */}
      <Box
        sx={{
          color: '#fff', // White text
          padding: '16px',
          textAlign: 'center',
          marginTop: '40px', // Ensures footer is pushed to the bottom of the content
        }}
      >
        <Typography variant="body2" sx={{ marginBottom: '8px' }}>
          &copy; 2024 OzConcert | 
          <Button sx={{ color: '#fff' }} href="/contacts"> Contacts </Button> | 
          <Button sx={{ color: '#fff' }} href="/privacy"> Privacy </Button>
        </Typography>
      </Box>
    </Box>
  );
}
